'use strict';

/**
 * Toggles video playback and updates the action button state.
 * @param {jQuery} $video - jQuery video element
 * @param {jQuery} $actionButton - jQuery action button element
 */
function toggleVideoPlayback($video, $actionButton) {
    if ($video[0].paused) {
        $video[0].play();
        $actionButton.removeClass('play').addClass('pause').attr('aria-label', 'pause');
    } else {
        $video[0].pause();
        $actionButton.addClass('play').removeClass('pause').attr('aria-label', 'play');
    }
}

/**
 * Syncs the action button CSS state to match the video's actual paused state.
 * @param {jQuery} $video - jQuery video element
 * @param {jQuery} $actionButton - jQuery action button element
 */
function syncButtonState($video, $actionButton) {
    $video[0].load();

    $video[0].pause();
    $actionButton.addClass('play').removeClass('pause').attr('aria-label', 'play');
}

/**
 * Initializes the video grid component.
 * @param {jQuery} $el - jQuery root element containing the video grid
 */
function initVideoGrid($el) {
    if (!$el || $el.length < 1) {
        return;
    }

    var $containers = $el.find('.features-video-grid__video-container');

    $containers.each(function () {
        var $container = $(this);
        var $video = $container.find('video');
        var $actionButton = $container.find('.features-video-grid__action-button');

        $container.on('click', function (e) {
            e.preventDefault();
            e.stopPropagation();
            toggleVideoPlayback($video, $actionButton);
        });

        $video.on('ended', function () {
            $actionButton.addClass('play').removeClass('pause').attr('aria-label', 'play');
        });
    });

    document.addEventListener('visibilitychange', function () {
        if (document.visibilityState === 'visible') {
            $containers.each(function () {
                var $container = $(this);
                var $video = $container.find('video');
                var $actionButton = $container.find('.features-video-grid__action-button');
                syncButtonState($video, $actionButton);
            });
        }
    });
}

module.exports = {
    initVideoGrid: initVideoGrid
};
